import { Component } from '@angular/core';

@Component({
  selector: 'mprd-skeleton-tv-level-two',
  templateUrl: './skeleton-tv-level-two.component.html',
})
export class SkeletonTvLevelTwoComponent {
  constructor() {}
}
